import { get } from 'lodash';
import { useMemo } from 'react';

import useEntity from './useEntity';

const useCoverImage = ({ id, version }) => {
  const { 'cover-image': coverImageParams } = useEntity({ id, type: 'stories' });

  const coverImage = useEntity(coverImageParams);

  const imgSrc = useMemo(() => get(coverImage, `['image-versions'][${version || 2}].url`, ''), [
    coverImage,
  ]);
  // if (!coverImage) return 'https://public-staging.lifetales.com/missing_story.jpg';
  return imgSrc;
};

export default useCoverImage;
